import { render, staticRenderFns } from "./MainJouFreeCard.vue?vue&type=template&id=14686e61&scoped=true&"
import script from "./MainJouFreeCard.vue?vue&type=script&lang=js&"
export * from "./MainJouFreeCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouFreeCard.vue?vue&type=style&index=0&id=14686e61&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14686e61",
  null
  
)

export default component.exports